import React from "react";
import { Menu, Button } from "antd";
import {
  DashboardOutlined,
  TeamOutlined,
  MailOutlined,
  FileTextOutlined,
  LogoutOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import "./Sidebar.css";
const Sidebar = ({ selectedMenuItem, onNavigate }) => {
  const history = useHistory();

  const onMenuItemClick = (key) => {
    history.push(`/admin/${key.toLowerCase()}`);
    if (onNavigate) {
      onNavigate();
    }
  };
  const handleLogout = () => {
    localStorage.removeItem("token");
    history.push("/admin/login");
    if (onNavigate) {
      onNavigate();
    }
  };
  const menuItems = [
    { key: "Dashboard", label: "Dashboard", icon: <DashboardOutlined /> },
    { key: "Experts", label: "Experts", icon: <TeamOutlined /> },
    { key: "Contacts", label: "Contacts", icon: <MailOutlined /> },
    { key: "Newsletter", label: "Newsletter", icon: <FileTextOutlined /> },
  ];
  return (
    <div className="admin-sidebar">
      <div className="admin-logo">
        <div className="admin-logo__badge">
          <AppstoreOutlined />
        </div>
        <div className="admin-logo__copy">
          <span className="admin-logo__eyebrow">Control Center</span>
          <img src="/img/logods.png" alt="Admin Logo" />
        </div>
      </div>
      <Menu
        mode="vertical"
        selectedKeys={[selectedMenuItem]}
        onClick={({ key }) => onMenuItemClick(key)}
        className="admin-sidebar__menu"
        items={menuItems}
      />
      <div className="admin-logout">
        <Button
          onClick={handleLogout}
          type="default"
          icon={<LogoutOutlined />}
          block
          className="admin-logout__button"
        >
          Logout
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
